export default "__VITE_ASSET__CeQjwI_V__"